import { render, staticRenderFns } from "./ActivationBriefOrderRouterView.vue?vue&type=template&id=05b3b45e&"
import script from "./ActivationBriefOrderRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOrderRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports